/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC721, ERC721Interface } from "../ERC721";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b5060405162002143380380620021438339818101604052810190620000379190620001f4565b81600090805190602001906200004f92919062000071565b5080600190805190602001906200006892919062000071565b5050506200029e565b8280546200007f906200025d565b90600052602060002090601f016020900481019282620000a35760008555620000ef565b82601f10620000be57805160ff1916838001178555620000ef565b82800160010185558215620000ef579182015b82811115620000ee578251825591602001919060010190620000d1565b5b509050620000fe919062000102565b5090565b5b808211156200011d57600081600090555060010162000103565b5090565b634e487b7160e01b600052604160045260246000fd5b600082601f8301126200014957600080fd5b815160018060401b038082111562000166576200016562000121565b5b601f1960405181603f83601f870116011681019150808210838311171562000193576200019262000121565b5b81604052838152602092508683858801011115620001b057600080fd5b600091505b83821015620001d5578282870101518383830101528282019150620001b5565b83821115620001e75760008385830101525b8094505050505092915050565b600080604083850312156200020857600080fd5b825160018060401b03808211156200021f57600080fd5b6200022d8683870162000137565b935060208501519150808211156200024457600080fd5b50620002538582860162000137565b9150509250929050565b60008160011c905060018216806200027657607f821691505b602082108114156200029857634e487b7160e01b600052602260045260246000fd5b50919050565b611e9580620002ae6000396000f3fe608060405234801561001057600080fd5b50600436106100df5760003560e01c80636352211e1161008c578063a22cb46511610066578063a22cb46514610234578063b88d4fde14610250578063c87b56dd1461026c578063e985e9c51461029c576100df565b80636352211e146101b657806370a08231146101e657806395d89b4114610216576100df565b8063095ea7b3116100bd578063095ea7b31461016257806323b872dd1461017e57806342842e0e1461019a576100df565b806301ffc9a7146100e457806306fdde0314610114578063081812fc14610132575b600080fd5b6100fe60048036038101906100f9919061141e565b6102cc565b60405161010b9190611445565b60405180910390f35b61011c6103ae565b60405161012991906114d7565b60405180910390f35b61014c600480360381019061014791906114f2565b610440565b604051610159919061150e565b60405180910390f35b61017c60048036038101906101779190611562565b6104c5565b005b6101986004803603810190610193919061158e565b6105dd565b005b6101b460048036038101906101af919061158e565b61063d565b005b6101d060048036038101906101cb91906114f2565b61065d565b6040516101dd919061150e565b60405180910390f35b61020060048036038101906101fb91906115ca565b61070f565b60405161020d91906115ed565b60405180910390f35b61021e6107c7565b60405161022b91906114d7565b60405180910390f35b61024e600480360381019061024991906115fe565b610859565b005b61026a60048036038101906102659190611669565b61086f565b005b610286600480360381019061028191906114f2565b6108d1565b60405161029391906114d7565b60405180910390f35b6102b660048036038101906102b19190611766565b610978565b6040516102c39190611445565b60405180910390f35b60007f80ac58cd000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916148061039757507f5b5e139f000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916145b806103a757506103a682610a0c565b5b9050919050565b6060600080546103bd90611799565b80601f01602080910402602001604051908101604052809291908181526020018280546103e990611799565b80156104365780601f1061040b57610100808354040283529160200191610436565b820191906000526020600020905b81548152906001019060200180831161041957829003601f168201915b5050505050905090565b600061044b82610a76565b61048a576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610481906117f1565b60405180910390fd5b6004600083815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050919050565b60006104d08261065d565b90508073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415610541576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161053890611855565b60405180910390fd5b8073ffffffffffffffffffffffffffffffffffffffff16610560610ae2565b73ffffffffffffffffffffffffffffffffffffffff16148061058f575061058e81610589610ae2565b610978565b5b6105ce576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016105c5906118b9565b60405180910390fd5b6105d88383610aea565b505050565b6105ee6105e8610ae2565b82610ba3565b61062d576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016106249061191d565b60405180910390fd5b610638838383610c81565b505050565b6106588383836040518060200160405280600081525061086f565b505050565b6000806002600084815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff161415610706576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016106fd90611981565b60405180910390fd5b80915050919050565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415610780576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610777906119e5565b60405180910390fd5b600360008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020549050919050565b6060600180546107d690611799565b80601f016020809104026020016040519081016040528092919081815260200182805461080290611799565b801561084f5780601f106108245761010080835404028352916020019161084f565b820191906000526020600020905b81548152906001019060200180831161083257829003601f168201915b5050505050905090565b61086b610864610ae2565b8383610ee8565b5050565b61088061087a610ae2565b83610ba3565b6108bf576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016108b69061191d565b60405180910390fd5b6108cb84848484611055565b50505050565b60606108dc82610a76565b61091b576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161091290611a49565b60405180910390fd5b60006109256110b1565b905060008151116109455760405180602001604052806000815250610970565b8061094f846110c8565b604051602001610960929190611aad565b6040516020818303038152906040525b915050919050565b6000600560008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149050919050565b60008073ffffffffffffffffffffffffffffffffffffffff166002600084815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614159050919050565b600033905090565b816004600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff16610b5d8361065d565b73ffffffffffffffffffffffffffffffffffffffff167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b6000610bae82610a76565b610bed576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610be490611ae2565b60405180910390fd5b6000610bf88361065d565b90508073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff161480610c3a5750610c398185610978565b5b80610c7857508373ffffffffffffffffffffffffffffffffffffffff16610c6084610440565b73ffffffffffffffffffffffffffffffffffffffff16145b91505092915050565b8273ffffffffffffffffffffffffffffffffffffffff16610ca18261065d565b73ffffffffffffffffffffffffffffffffffffffff1614610cf7576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610cee90611b46565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415610d67576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d5e90611baa565b60405180910390fd5b610d72838383611229565b610d7d600082610aea565b6001600360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828254610dcd9190611c3d565b925050819055506001600360008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828254610e249190611c5b565b92505081905550816002600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a4610ee383838361122e565b505050565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415610f57576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f4e90611c7a565b60405180910390fd5b80600560008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31836040516110489190611445565b60405180910390a3505050565b611060848484610c81565b61106c84848484611233565b6110ab576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016110a290611cb8565b60405180910390fd5b50505050565b606060405180602001604052806000815250905090565b60606000821415611110576040518060400160405280600181526020017f30000000000000000000000000000000000000000000000000000000000000008152509050611224565b600082905060005b6000821461114257808061112b90611d1c565b915050600a8261113b9190611d89565b9150611118565b60008167ffffffffffffffff81111561115e5761115d61163a565b5b6040519080825280601f01601f1916602001820160405280156111905781602001600182028036833780820191505090505b5090505b6000851461121d576001826111a99190611c3d565b9150600a856111b89190611da4565b60306111c49190611c5b565b60f81b8183815181106111da576111d9611dbf565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a905350600a856112169190611d89565b9450611194565b8093505050505b919050565b505050565b505050565b60006112548473ffffffffffffffffffffffffffffffffffffffff166113ca565b156113bd578373ffffffffffffffffffffffffffffffffffffffff1663150b7a0261127d610ae2565b8786866040518563ffffffff1660e01b815260040161129f9493929190611dee565b602060405180830381600087803b1580156112b957600080fd5b505af19250505080156112ea57506040513d601f19601f820116820180604052508101906112e79190611e38565b60015b61136d573d806000811461131a576040519150601f19603f3d011682016040523d82523d6000602084013e61131f565b606091505b50600081511415611365576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161135c90611cb8565b60405180910390fd5b805181602001fd5b63150b7a0260e01b7bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916817bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149150506113c2565b600190505b949350505050565b6000808273ffffffffffffffffffffffffffffffffffffffff163b119050919050565b7fffffffff000000000000000000000000000000000000000000000000000000008116811461141b57600080fd5b50565b60006020828403121561143057600080fd5b813561143b816113ed565b8091505092915050565b6000602082019050821515825292915050565b60005b8381101561147657808201518184015260208101905061145b565b83811115611485576000848401525b50505050565b600081518084526114a3816020860160208601611458565b60207fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f83011685010191505092915050565b6020815260006114ea602083018461148b565b905092915050565b60006020828403121561150457600080fd5b8135905092915050565b600060208201905073ffffffffffffffffffffffffffffffffffffffff8316825292915050565b60008135905073ffffffffffffffffffffffffffffffffffffffff8116811461155d57600080fd5b919050565b6000806040838503121561157557600080fd5b61157e83611535565b9150602083013590509250929050565b6000806000606084860312156115a357600080fd5b6115ac84611535565b92506115ba60208501611535565b9150604084013590509250925092565b6000602082840312156115dc57600080fd5b6115e582611535565b905092915050565b600060208201905082825292915050565b6000806040838503121561161157600080fd5b61161a83611535565b91506020830135801515811461162f57600080fd5b809150509250929050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6000806000806080858703121561167f57600080fd5b61168885611535565b935061169660208601611535565b925060408501359150606085013567ffffffffffffffff808211156116ba57600080fd5b818701915087601f8301126116ce57600080fd5b8135818111156116e1576116e061163a565b5b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe060405181603f83601f86011601168101915080821084831117156117295761172861163a565b5b816040528281528a602084870101111561174257600080fd5b82602086016020830137600060208483010152809550505050505092959194509250565b6000806040838503121561177957600080fd5b61178283611535565b915061179060208401611535565b90509250929050565b60008160011c905060018216806117b157607f821691505b602082108114156117eb577f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b50919050565b60208152602c60208201527f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860408201527f697374656e7420746f6b656e000000000000000000000000000000000000000060608201526000608082019050919050565b60208152602160208201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e6560408201527f720000000000000000000000000000000000000000000000000000000000000060608201526000608082019050919050565b60208152603860208201527f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f7760408201527f6e6572206e6f7220617070726f76656420666f7220616c6c000000000000000060608201526000608082019050919050565b60208152603160208201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f60408201527f776e6572206e6f7220617070726f76656400000000000000000000000000000060608201526000608082019050919050565b60208152602960208201527f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460408201527f656e7420746f6b656e000000000000000000000000000000000000000000000060608201526000608082019050919050565b60208152602a60208201527f4552433732313a2062616c616e636520717565727920666f7220746865207a6560408201527f726f20616464726573730000000000000000000000000000000000000000000060608201526000608082019050919050565b60208152602f60208201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60408201527f6e6578697374656e7420746f6b656e000000000000000000000000000000000060608201526000608082019050919050565b60008351611abf818460208801611458565b80830190508351611ad4818360208801611458565b808201925050509392505050565b60208152602c60208201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860408201527f697374656e7420746f6b656e000000000000000000000000000000000000000060608201526000608082019050919050565b60208152602560208201527f4552433732313a207472616e736665722066726f6d20696e636f72726563742060408201527f6f776e657200000000000000000000000000000000000000000000000000000060608201526000608082019050919050565b60208152602460208201527f4552433732313a207472616e7366657220746f20746865207a65726f2061646460408201527f726573730000000000000000000000000000000000000000000000000000000060608201526000608082019050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b600082821015611c5057611c4f611c0e565b5b828203905092915050565b60008219821115611c6f57611c6e611c0e565b5b828201905092915050565b60208152601960208201527f4552433732313a20617070726f766520746f2063616c6c65720000000000000060408201526000606082019050919050565b60208152603260208201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560408201527f63656976657220696d706c656d656e746572000000000000000000000000000060608201526000608082019050919050565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff821415611d4f57611d4e611c0e565b5b600182019050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b600082611d9957611d98611d5a565b5b828204905092915050565b600082611db457611db3611d5a565b5b828206905092915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b600073ffffffffffffffffffffffffffffffffffffffff808716835280861660208401525083604083015260806060830152611e2d608083018461148b565b905095945050505050565b600060208284031215611e4a57600080fd5b8151611e55816113ed565b809150509291505056fea2646970667358221220672c71df5fd1215665c854bd99375444ac45a6ba3f3840674c596bf3dd3ef3fc64736f6c63430008090033";

export class ERC721__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    name_: string,
    symbol_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721> {
    return super.deploy(name_, symbol_, overrides || {}) as Promise<ERC721>;
  }
  getDeployTransaction(
    name_: string,
    symbol_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(name_, symbol_, overrides || {});
  }
  attach(address: string): ERC721 {
    return super.attach(address) as ERC721;
  }
  connect(signer: Signer): ERC721__factory {
    return super.connect(signer) as ERC721__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721Interface {
    return new utils.Interface(_abi) as ERC721Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC721 {
    return new Contract(address, _abi, signerOrProvider) as ERC721;
  }
}
